export default "__VITE_ASSET__3874a982__"